export const paaas = [
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2026.pdf",
        "year" :"2026",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2025.pdf",
        "year" :"2025",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2024.pdf",
        "year" :"2024",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2023.rar",
        "year" :"2023",
        "icon" : "icon-file-rar"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2022.rar",
        "year" :"2022",
        "icon" : "icon-file-rar"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2021.rar",
        "year" :"2021",
        "icon" : "icon-file-rar"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2020.rar",
        "year" :"2020",
        "icon" : "icon-file-rar"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2019.rar",
        "year" :"2019",
        "icon" : "icon-file-rar"
    },
    // {
    //     "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios",
    //     "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAAAS/PAAAS-2018.pdf",
    //     "year" :"2018",
    //     "icon" : "icon-file-pdf"
    // },
]